<a
  class="visually-hidden-focusable position-absolute top-0 start-0 m-2 btn btn-sm btn-primary z-3"
  href="#main-content"
>
  Skip to main content
</a>
<main id="main-content" class="remmi-app-page" tabindex="-1">
  <router-outlet />
</main>
<app-ui-modal-host />
<app-ui-toast-host />
